import PhotoOrderingOverlayModal, {
  ALBUM_SLIDESHOW_DESIGNER_PHOTO_ORDERING_MODAL,
} from './modal';

export { ALBUM_SLIDESHOW_DESIGNER_PHOTO_ORDERING_MODAL };
export default PhotoOrderingOverlayModal;
